package one.healthium.domain.health_log

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import one.healthium.domain.health_log.models.HealthLogModel
import one.healthium.domain.health_log.models.HealthLogOption
import one.healthium.domain.health_log.models.HealthLogQuestionModel
import one.healthium.domain.user.UserInteractor

class HealthLogInteractor(
    private val healthLogRepository: HealthLogRepository,
    private val userInteractor: UserInteractor
) {
    suspend fun getHealthLogQuestions(): List<HealthLogQuestionModel> {
        return healthLogRepository.getHealthLogQuestions()
    }

    suspend fun addHealthLog(options: List<HealthLogOption>, taskId: String? = null) {
        userInteractor.addHealthLog(options, taskId)
    }

    fun getTodayHealthLog(): Flow<HealthLogModel?> {
        return userInteractor.observeUser()
            .map { user -> user.todayHealthLog }
    }
}